import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { HeaderGlobalComponent } from './components/header-global/header-global.component';
import { HeaderWorkspaceComponent } from './components/header-workspace/header-workspace.component';
import { EntityInstance } from '@meplis/common';
import { SocialService } from '../../../services/application/social.service';
import { ProfileService } from '@cnp/services';
import { Subscription, switchMap } from 'rxjs';
import { AuthenticationService } from '../../../services/application/authentication.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    HeaderGlobalComponent,
    HeaderWorkspaceComponent
],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private _socialService = inject(SocialService);
  private _authService = inject(AuthenticationService);
  private _profileService = inject(ProfileService);

  public userInstance: EntityInstance;

  public authSubscription: Subscription;
  public userInstanceSubscription: Subscription;
  public userInstanceChangedSubscription: Subscription;
  public profileChangedSubscription: Subscription;

  public ngOnInit(): void {
    // Load user instance on init only when authenticated
    if (this._authService.isLogged) {
      this._socialService.getUserInstance().subscribe((userInstance) => {
        this.userInstance = userInstance;
      });
    }

    // Listen for login/logout events
    this.authSubscription = this._authService.onLoggedInOut
      .pipe(switchMap(() => this._socialService.getUserInstance()))
      .subscribe((userInstance) => {
        this.userInstance = userInstance;
      });

    // Listen for user instance changes (e.g. unlock global features)
    this.userInstanceChangedSubscription = this._socialService
      .onUserInstanceChanged()
      .subscribe((userInstance) => {
        this.userInstance = userInstance;
      });

    // Listen for profile changes to refresh userInstance
    this.profileChangedSubscription = this._profileService.onProfileChanged
      .pipe(
        switchMap(() => {
          this._socialService.clearUserInstance();
          return this._socialService.getUserInstance();
        })
      )
      .subscribe((userInstance) => {
        this.userInstance = userInstance;
      });
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
    this.userInstanceSubscription?.unsubscribe();
    this.userInstanceChangedSubscription?.unsubscribe();
    this.profileChangedSubscription?.unsubscribe();
  }
}
